import LoadingBox from 'components/Common/Loading/LoadingBox'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'

const Container = styled.div`
  background: ${props => props.theme.palette.neutral.default.seven};
  box-shadow: 0 0 0 ${rem(1)} ${props => props.theme.palette.neutral.default.six};
  border-radius: ${props => props.theme.borderRadius.L};
  position: relative;
  display: grid;
  gap: ${rem(16)};
  padding: ${rem(16)};
  grid-template: "image content" auto / ${rem(80)} 1fr;

  ${mediaQueryUp.tablet} {
    padding: 0;
    gap: 0;
    grid-template:
      "image" ${rem(80)}
      "content" auto / auto;
    grid-row-gap: ${rem(12)};

    &.layout-horizontal {
      gap: ${rem(16)};
      padding: ${rem(16)};
      grid-template: "image content" auto / auto 1fr;
    }
  }
`

const ImageContainer = styled.div`
  grid-area: image;
  display: flex;
  overflow: hidden;
  align-self: stretch;
  border-radius:  ${props => props.theme.borderRadius.L} 0 0  ${props => props.theme.borderRadius.L};
  /* Default mobile + desktop horizontal */

  ${mediaQueryUp.tablet} {
    align-self: stretch;
    border-radius:  ${props => props.theme.borderRadius.L} ${props => props.theme.borderRadius.L} 0 0;
  }
`

const ContentContainer = styled(Group)`
  grid-area: content;
  margin: ${rem(16)} 0;

  ${mediaQueryUp.tablet} {
    margin: 0 ${rem(16)} ${rem(20)} ${rem(16)};
  }
`

const ImagePlaceholder = styled(LoadingBox)`
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1;
`

const TitlePlaceholder = styled(LoadingBox)`
  height: ${rem(20)};
  width: 80%;
`

function LoadingImageTileCard() {
  return (
    <Container>
      <ImageContainer>
        <ImagePlaceholder />
      </ImageContainer>

      <ContentContainer direction="vertical" verticalAlign="center" gap={2}>
        <TitlePlaceholder borderRadius="S" />

      </ContentContainer>
    </Container>
  )
}

export default LoadingImageTileCard
